import type { ComponentProps } from 'react';
import { ModalDialog } from '~/features/vault/documents/ModalDialog';
import { ServiceCounterEditor } from './ServiceCounterEditor';

type Props = ComponentProps<typeof ServiceCounterEditor> & { open: boolean };

/**
 * The counteroffer opens in the same "Negotiation" modal the job and B2B
 * responses use. Every way of closing it discards the counter draft.
 */
export const ServiceNegotiationModal = ({ open, ...editor }: Props) => (
  <ModalDialog
    open={open}
    onClose={editor.onClose}
    closeDisabled={editor.disabled}
    title="Negotiation"
    xButton
  >
    <ServiceCounterEditor {...editor} />
  </ModalDialog>
);
